<template lang="pug">
    .box-parent-exercise
      .box-item-exercise
        router-link.grade-format(:to="{ path: '/' + url + '/exercise/' + exercise.grade_id, params: {grade_id: exercise.grade_id, front_top: 0}}") {{exercise.grade_name}}
        .overlay(@click="viewDetail(exercise)")
        .item-title
          a(@click="viewDetail(exercise)")
            span {{exercise.name}}
      .item-social
        span
          i.like.fa(@click="likeExercise(exercise.id)" v-if="!liked || !$store.getters.user")
            img(src="../../../../assets/images/home/ic_like_outline.svg")
            | {{ $mycontroller.numberWithCommas(exercise.count_like) }}
          i.like.fa(@click="unLikeExercise(exercise.id)" v-if="liked && $store.getters.user")
            img(src="../../../../assets/images/home/ic_like.svg")
            | {{ $mycontroller.numberWithCommas(exercise.count_like) }}
        span
          i.fa
            img(src="../../../../assets/images/home/ic_comment.svg")
            | {{ $mycontroller.numberWithCommas(exercise.count_comment) }}
        span
          i.fa
            img(src="../../../../assets/images/home/ic_share.svg")
            | {{ $mycontroller.numberWithCommas(exercise.count_share) }}
</template>
<script>
import gql from 'graphql-tag'
import graphql from '../../../Model/graphqlfront'
import LoginModal from '@/components/Account/LoginModal'
export default {
  props: {
    exercise: Object,
    obj_id: Number,
    url: String
  },
  data() {
    return {
      object_id: this.obj_id,
      isSucess: false,
      liked: false
    }
  },
  methods: {
    getLinkDetail(item) {
      var link = window.location.origin + '/' + this.$router.resolve({name: 'landing'}).href + this.url
      return link + '/exercise/detail/' + item.id
    },
    getLinkDetailPush(item) {
      return '/' + this.url + '/exercise/detail/' + item.id
    },
    getLinkCurrent(id) {
      this.$store.commit('setIsHomePage', true)
      var path = this.$route.path
      if (path.length > 0 && path[0] === '/') path = this.$mycontroller.removeByIndexFromString(path, 1)
      var link = window.location.origin + '/' + this.$router.resolve({path: '/'}).href
      return link + path + '?like=1'
    },
    viewDetail(item) {
      if (!this.$store.getters.isLoggedIn) {
        try {
          let scrollTop = this.$mycontroller.getScrollTop(window)
          var params = this.$route.params
          params = Object.assign(params, {name: this.$route.name})
          params = Object.assign(params, {front_top: scrollTop})
          params = Object.assign(params, {object_id: item.id})
          params = Object.assign(params, {url: this.getLinkDetail(item)})
          localStorage.setItem('renew', 1)
          localStorage.setItem('classme', item.class_id)
          this.$modal.show(LoginModal, {params: params}, {
            // width: '43%',
            height: 'auto',
            classes: ['col-6'],
            adaptive: true,
            resize: true,
            clickToClose: false
          })
        } catch (e) {}
      } else {
        localStorage.setItem('renew', 1)
        localStorage.setItem('classme', item.class_id)
        window.location.href = this.getLinkDetail(item)
      }
    },
    likeExercise(id) {
      if (!this.$store.getters.isLoggedIn) {
        let scrollTop = this.$mycontroller.getScrollTop(window)
        var params = this.$route.params
        params = Object.assign(params, {name: this.$route.name})
        params = Object.assign(params, {front_top: scrollTop})
        params = Object.assign(params, {object_id: id})
        params = Object.assign(params, {like: true})
        params = Object.assign(params, {likeName: 'like'})
        params = Object.assign(params, {url: this.getLinkCurrent(id)})
        try {
          this.$modal.show(LoginModal, {params: params}, {
            // width: '43%',
            height: 'auto',
            classes: ['col-6'],
            adaptive: true,
            resize: true,
            clickToClose: false
          })
        } catch (e) {}
      } else {
        if (!this.isSucess) {
          this.isSucess = true
          this.$apollo.mutate({
            mutation: gql(graphql.LIKE_EXERCISE),
            variables: {
              objectInput: {
                object_id: id,
                user_id: this.$store.getters.user
              }
            },
            update: (store, { data: { insert_like_exercise } }) => {
              if (insert_like_exercise.affected_rows) {
                this.liked = true
                this.exercise.count_like++
              }
              this.isSucess = false
            }
          }).catch((error) => {
            console.log('error', error)
            if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
              this.$router.go(0, this.$route.params, this.$route.query)
            }
          })
        }
      }
    },
    unLikeExercise(id) {
      if (!this.$store.getters.isLoggedIn) {
        let scrollTop = this.$mycontroller.getScrollTop(window)
        var params = this.$route.params
        params = Object.assign(params, {name: this.$route.name})
        params = Object.assign(params, {front_top: scrollTop})
        params = Object.assign(params, {object_id: id})
        params = Object.assign(params, {like: false})
        params = Object.assign(params, {likeName: 'like'})
        params = Object.assign(params, {url: this.getLinkCurrent(id)})
        try {
          this.$modal.show(LoginModal, {params: params}, {
            // width: '43%',
            height: 'auto',
            classes: ['col-6'],
            adaptive: true,
            resize: true,
            clickToClose: false
          })
        } catch (e) {}
      } else {
        if (!this.isSucess) {
          this.isSucess = true
          this.$apollo.mutate({
            mutation: gql(graphql.UNLIKE_EXERCISE),
            variables: {
              objectWhere: {
                object_id: {_eq: id},
                user_id: {_eq: this.$store.getters.user}
              }
            },
            update: (store, { data: { delete_like_exercise } }) => {
              if (delete_like_exercise.affected_rows) {
                this.liked = false
                this.exercise.count_like--
              }
              this.isSucess = false
            }
          }).catch((error) => {
            console.log('error', error)
            if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
              this.$router.go(0, this.$route.params, this.$route.query)
            }
          })
        }
      }
    },
    isMobile() {
      if (window.innerWidth < 991) return true
      return false
    }
  },
  async mounted () {
    this.liked = false
    if (this.$store.getters.isLoggedIn) {
      await this.$apollo.query({
        query: gql(graphql.GET_LIKE_EXERCISE),
        fetchPolicy: 'no-cache',
        variables: {
          where: {
            object_id: {_eq: this.object_id},
            user_id: {_eq: this.$store.getters.user}
          }
        }}).then((response) => {
          this.liked = response.data.like_exercise.length > 0
        }).catch((error) => {
          if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
            this.$router.go(0, this.$route.params, this.$route.query)
          }
        })
      var returnLike = this.$mycontroller.openStorage('like')
      if (returnLike !== undefined && returnLike !== null && Number(returnLike) > 0 && this.exercise.id === Number(returnLike)) {
        this.isSucess = false
        this.$mycontroller.clearStorage('like')
        if (this.liked) this.unLikeExercise(Number(returnLike))
        else this.likeExercise(Number(returnLike))
      }
    }
  },
  apollo: {
  }
}
</script>
<style lang="scss">
</style>




// WEBPACK FOOTER //
// item.vue?5f37e2a7